import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['grid']

  connect() {
    this.adjustHeight()

    this.adjustHeight = this.adjustHeight.bind(this)
    window.addEventListener('resize', this.adjustHeight)
  }

  disconnect() {
    window.removeEventListener('resize', this.adjustHeight)
  }

  adjustHeight() {
    const gridElement = this.gridTarget
    const availableHeight = Math.max(350, window.innerHeight - gridElement.getBoundingClientRect().top - 20)
    gridElement.style.height = `${availableHeight}px`
  }
}
